import image4 from'./Images/pexels-andrea-piacquadio-3771839.jpg'


export  const AboutData =[
    {
        id:1,
        image:image4,
                },
    
]